/**
 * Minimizes the sidebar on tablet screens (768px - 1024px)
 * This function mimics the behavior of the hamburger menu toggle
 * but specifically minimizes the sidebar for tablet viewports
 */
export const minimizeSidebarOnTablet = () => {
  const windowSize = document.documentElement.clientWidth;
  const layoutType = document.documentElement.getAttribute("data-layout");

  // Only minimize on tablet screens (768px - 1024px)
  // This matches the tablet breakpoint logic in Header.tsx
  if (windowSize >= 768 && windowSize < 1025) {
    // For vertical layout (most common)
    if (layoutType === "vertical") {
      document.body.classList.remove("vertical-sidebar-enable");
      document.documentElement.setAttribute("data-sidebar-size", "sm");
      // Also toggle hamburger icon to "open" state to indicate sidebar is minimized
      document.querySelector(".hamburger-icon")?.classList.add("open");
    }
    // For horizontal layout
    else if (layoutType === "horizontal") {
      document.body.classList.add("menu");
    }
    // For two-column layout
    else if (layoutType === "twocolumn") {
      document.body.classList.add("twocolumn-panel");
    }
  }
};

/**
 * Checks if the current viewport is a tablet screen
 * @returns boolean - true if viewport width is between 768px and 1024px
 */
export const isTabletScreen = (): boolean => {
  const windowSize = document.documentElement.clientWidth;
  return windowSize >= 768 && windowSize < 1025;
};

